import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Movimentação",
  path: "/prestacaocontas/pcomovimentacao",
  name: "pcomovimentacao",
  component: () => import("@/views/prestacaocontas/pcomovimentacao/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOBANCARIANOVO_MENU_2900200199],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Movimentação",
  path: "/prestacaocontas/pcomovimentacao/cadastro/:id?",
  parent: "pcomovimentacao",
  name: "pcomovimentacao_create",
  component: () => import("@/views/prestacaocontas/pcomovimentacao/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOBANCARIANOVO_MENU_2900200199],
  },
  goesToMenu: true,
 },
]
